var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-layout"},[_c('navbar-top',{attrs:{"button-text":_vm.navbarTopButtonText,"button-to":_vm.navbarTopButtonTo}}),_c('main',[_vm._t("default",[_vm._v("Main content will appear here")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }